import { PROFILE_ERROR, GET_PROFILE, PROFILE_SUCCESS, EDIT_PROFILE, RESET_PROFILE_FLAG, CHANGE_AVARTAR_PROFILE } from "./actionTypes"

export const editProfile = user => {
  return {
    type: EDIT_PROFILE,
    payload: { user },
  }
}

export const getProfile = userId => {
  return {
    type: GET_PROFILE,
    payload: { userId },
  }
}

export const profileSuccess = msg => {
  return {
    type: PROFILE_SUCCESS,
    payload: msg,
  }
}

export const profileError = error => {
  return {
    type: PROFILE_ERROR,
    payload: error,
  }
}

export const resetProfileFlag = error => {
  return {
    type: RESET_PROFILE_FLAG,
  }
}

export const changeAvartarProfile = data => {
  return {
    type: CHANGE_AVARTAR_PROFILE,
    payload: data,
  }
}

